import * as React from 'react';
import { PrescriberDetailCRM } from './views/PrescriberDetailCRM';
import CRMRoot from './views/CRMRoot';
import { crmBasePath } from './constants/paths';

export const CRMRouter = {
    path: crmBasePath,
    element: <CRMRoot />,
    handle: { title: 'CRM' },
    children: [
        {
            path: 'prescripteur/:id',
            element: <PrescriberDetailCRM />,
            handle: { title: 'CRM - Fiche prescripteur' },
        },
    ],
};
